import { useParams } from "react-router-dom";
import FormPage from "../../components/forms/FormPage";
import useColophonController from "../../controllers/colophonController";
import FormTextField from "../../components/forms/fields/basic/TextField";
import renderPersonSelection from "../../components/entitiesReferences/SelectionModals/PersonSelectionModal";
import renderWorkSelection from "../../components/entitiesReferences/SelectionModals/WorkSelectionModal";
import FormVersionRef from "../../components/forms/common/subForms/VersionRef";
import FormEntitySelectionField from "../../components/forms/fields/basic/EntitySelectionField";
import AccordionSubFormContainer from "../../components/forms/fields/subForms/accordion/AccordionSubFormContainer";
import AccordionSubForm from "../../components/forms/fields/subForms/accordion/AccordionSubForm";
import VersionsList from "./VersionsList";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { SystemLanguages } from "../../shared/enums/shared-enums";
import NameInternalEvidence from "../../components/forms/common/subForms/NameInternalEvidence";

const AddEditColophonPage: React.FC = () => {
  const { _id = null } = useParams<{ _id?: string }>();
  const controller = useColophonController(_id);
  const formController = { ...controller, title: controller.editTitle };

  return (
    <FormPage controller={formController}>
      <FormEntitySelectionField
        name="work"
        label="Work"
        placeholder="Select a work"
        entityCollection={SystemEntityCollections.WORK}
        renderEntitySelection={renderWorkSelection(SystemLanguages.tibetan)}
        required
      />
      <FormTextField
        name="colophon"
        label="Colophon"
        placeholder="Enter colophon data"
        required
      />
      <FormEntitySelectionField
        name="author"
        label="Author of Colophon"
        placeholder="Select an author"
        entityCollection={SystemEntityCollections.PERSON}
        renderEntitySelection={renderPersonSelection}
      />
      <AccordionSubFormContainer>
        <AccordionSubForm
          name="name_internal_evidence"
          label="Name Internal Evidence"
        >
          <NameInternalEvidence />
        </AccordionSubForm>
      </AccordionSubFormContainer>
      <FormVersionRef name="version" language={SystemLanguages.tibetan} />
      <VersionsList
        name="virtually_identical_with"
        label="Virtually Identical With"
        rowLabel="Version"
        language={SystemLanguages.tibetan}
      />
    </FormPage>
  );
};

export default AddEditColophonPage;
